export default "__VITE_ASSET__BwQqMRhZ__"